const cacheKey = 'create:selectedModel';

export function getCurrentModel() {
  // 从 localStorage 获取上次选择的模型，如果没有则使用默认值
  const lastSelectedModel = localStorage.getItem(cacheKey);
  if (lastSelectedModel) {
    // 检查 lastSelectedModel 是否在可用的 models 列表中
    const isValidModel = models.find((model) => model.value === lastSelectedModel);
    if (isValidModel) {
      return lastSelectedModel;
    }
  }
  return models[0].value;
}

export function setCurrentModel(model) {
  localStorage.setItem(cacheKey, model);
}

export const TASKS = {
  analysis: 'analysis',
  style: 'style',
  typography: 'typography',
  layout: 'layout',
  code: 'code',
  generate: 'generate',
  build: 'build',
  color: 'color',
  image: 'image',
};

export const TASK_STATUS = {
  pending: 'pending',
  started: 'in-progress',
  inProgress: 'in-progress',
  completed: 'completed',
  failed: 'failed',
};

export const defaultTasks = [
  {
    name: TASKS.analysis,
    status: TASK_STATUS.pending,
  },
  {
    name: TASKS.style,
    status: TASK_STATUS.pending,
  },
  {
    name: TASKS.typography,
    status: TASK_STATUS.pending,
  },
  {
    name: TASKS.layout,
    status: TASK_STATUS.pending,
  },
  {
    name: TASKS.code,
    status: TASK_STATUS.pending,
  },
  {
    name: TASKS.build,
    status: TASK_STATUS.pending,
  },
  {
    name: TASKS.image,
    status: TASK_STATUS.pending,
  },
];

export const defaultGenerateFastTasks = [
  {
    name: TASKS.analysis,
    status: TASK_STATUS.pending,
  },
  {
    name: TASKS.layout,
    status: TASK_STATUS.pending,
  },
  {
    name: TASKS.build,
    status: TASK_STATUS.pending,
  },
  {
    name: TASKS.image,
    status: TASK_STATUS.pending,
  },
];

export const models = [
  {
    icon: 'gemini',
    label: 'Gemini 3 Pro',
    value: 'gemini-3-pro',
    isNew: true,
    creditsCost: 2,
    isDiscount: true,
    isPro: true,
    supportImage: true,
    description: "Google's advanced model with enhanced creative capabilities",
    descriptions: {
      en: 'Good for ambitious and creative tasks.',
      zh: '首选推荐，适合创意和复杂任务',
    },
  },
  {
    icon: 'gemini',
    label: 'Gemini 2.5 Pro',
    value: 'gemini-2.5-pro',
    creditsCost: 2,
    isDiscount: true,
    isPro: true,
    supportImage: true,
    description: "Google's advanced model with enhanced creative capabilities",
    descriptions: {
      en: 'For daily design and quick responses.',
      zh: '日常任务和快速响应',
    },
  },
  {
    icon: 'gemini',
    label: 'Gemini 2.5 Flash',
    value: 'gemini-2.5-flash',
    creditsCost: 1,
    isDev: true,
    supportImage: true,
    description: 'Fast and efficient model optimized for quick, simple design tasks',
    descriptions: {
      en: 'Fast and efficient model optimized for quick, simple design tasks',
      zh: '高效快速的模型，专为快速简单设计任务优化',
    },
  },
  {
    icon: 'claude',
    label: 'Claude 4.5',
    value: 'claude-4-5-sonnet',
    creditsCost: 2,
    isDiscount: true,
    isPro: true,
    supportImage: true,
    description: 'The most advanced model with superior creative capabilities',
    descriptions: {
      en: 'The most advanced model with superior creative capabilities',
      zh: '卓越的创意能力',
    },
  },
  {
    icon: 'openai',
    label: 'GPT-5',
    value: 'gpt-5',
    creditsCost: 2,
    supportImage: true,

    description: 'GPT-5 latest',
    descriptions: {
      en: "OpenAI's most advanced model",
      zh: 'OpenAI 最先进的模型',
    },
  },
  {
    icon: 'moonshot',
    label: 'Kimi K2 Thinking',
    value: 'kimi-k2-thinking',
    creditsCost: 1,
    isDev: true,
    description: 'Kimi K2',
    descriptions: {
      en: "Moonshot's latest model",
      zh: '月之暗面的最新旗舰模型',
    },
  },
  {
    icon: 'moonshot',
    label: 'Kimi K2',
    value: 'kimi-k2',
    creditsCost: 1,
    isDev: true,
    description: 'Kimi K2',
    descriptions: {
      en: "Moonshot's latest model",
      zh: '月之暗面的最新旗舰模型',
    },
  },
  {
    icon: 'openai',
    label: 'GPT-5 mini',
    value: 'gpt-5-mini',
    creditsCost: 1,
    supportImage: true,
    isNew: true,
    description: 'GPT-5 latest',
    descriptions: {
      en: "OpenAI's most advanced model",
      zh: 'OpenAI 最先进的模型',
    },
  },
  {
    icon: 'qwen',
    label: 'Qwen3 Max',
    value: 'qwen3-max',
    creditsCost: 1,
    description: 'Most agentic code model with 256K context and Claude Sonnet-level performance',
    descriptions: {
      en: 'Most agentic code model with 256K context',
      zh: '最具智能体能力的代码模型，支持 256K 上下文',
    },
  },
  {
    icon: 'qwen',
    label: 'Qwen3 Coder',
    value: 'qwen3-coder',
    creditsCost: 1,
    isDev: true,
    description: 'Most agentic code model with 256K context and Claude Sonnet-level performance',
    descriptions: {
      en: 'Most agentic code model with 256K context',
      zh: '最具智能体能力的代码模型，支持 256K 上下文',
    },
  },
  {
    icon: 'deepseek',
    label: 'Deepseek V3.1',
    creditsCost: 1,
    isPro: true,
    supportImage: false,
    value: 'deepseek-v3.1',
    description: 'Versatile model with strong visual design capabilities',
    descriptions: {
      en: 'Versatile model with strong visual design capabilities',
      zh: 'Deepseek 最新模型，具有强大的视觉设计能力',
    },
  },
  {
    icon: 'deepseek',
    label: 'Deepseek V3',
    creditsCost: 1,
    isPro: true,
    supportImage: false,
    value: 'deepseek-v3',
    description: 'Versatile model with strong visual design capabilities',
    descriptions: {
      en: 'Versatile model with strong visual design capabilities',
      zh: 'Deepseek 最新模型，具有强大的视觉设计能力',
    },
  },
  {
    icon: 'claude',
    label: 'Claude 4',
    value: 'claude-4-sonnet',
    creditsCost: 2,
    isDiscount: true,
    isPro: true,
    supportImage: true,
    description: 'Latest Claude model with superior creative capabilities',
    descriptions: {
      en: 'Latest Claude model with superior creative capabilities',
      zh: '最新的 Claude 模型，具有卓越的创意能力',
    },
  },
  {
    icon: 'claude',
    label: 'Claude 3.7',
    value: 'claude-3-7-sonnet',
    creditsCost: 2,
    isDiscount: true,
    supportImage: true,
    description: 'Latest Claude model with superior creative capabilities',
    descriptions: {
      en: 'Latest Claude model with superior creative capabilities',
      zh: '上一代 Claude 模型，具有卓越的创意能力',
    },
  },
  {
    icon: 'openai',
    label: 'GPT-4.1',
    value: 'gpt-4.1',
    creditsCost: 2,
    isDiscount: true,
    supportImage: true,
    description: 'GPT-4.1 latest',
    descriptions: {
      en: "OpenAI's most advanced model",
      zh: 'OpenAI 最先进的模型',
    },
  },
  {
    icon: 'openai',
    label: 'GPT-4.1 Mini',
    value: 'gpt-4.1-mini',
    creditsCost: 1,
    supportImage: true,
    description: 'GPT-4.1 Mini latest',
    descriptions: {
      en: "OpenAI's most advanced model",
      zh: 'OpenAI 最先进的模型',
    },
  },
  {
    icon: 'openai',
    label: 'o4 mini',
    value: 'o4-mini',
    creditsCost: 2,
    isDiscount: true,
    supportImage: true,
    description: 'o4 mini',
    descriptions: {
      en: 'o4 mini',
      zh: 'o4 mini',
    },
  },
  {
    icon: 'deepseek',
    label: 'Deepseek R1',
    creditsCost: 1,
    isPro: true,
    supportImage: false,
    isNew: true,
    reasoning: true,
    value: 'deepseek-r1',
    description: 'Versatile model with strong visual design capabilities',
    descriptions: {
      en: 'Versatile model with strong visual design capabilities',
      zh: 'Deepseek 最新模型，具有强大的视觉设计能力',
    },
  },
  {
    icon: 'doubao',
    label: 'Doubao 1.6 Thinking',
    value: 'doubao-seed-1-6-thinking',
    creditsCost: 1,
    isDev: true,
    supportImage: true,
    reasoning: true,
    description: "ByteDance's model with enhanced reasoning capabilities",
    descriptions: {
      en: "ByteDance's latest model, supports visual understanding.",
      zh: '字节跳动的最新模型，思考能力大幅强化，支持视觉理解。',
    },
  },
  {
    icon: 'minimax',
    label: 'MiniMax M2',
    value: 'minimax-m2',
    creditsCost: 1,
    isDev: true,
    reasoning: true,
    description: "MiniMax's latest model with native ultra-long context support",
    descriptions: {
      en: "MiniMax's latest model with native ultra-long context support",
      zh: 'MiniMax 的最新模型，原生支持超长上下文',
    },
  },
  {
    icon: 'zai',
    label: 'GLM 4.6',
    value: 'glm-4.6',
    creditsCost: 1,
    description: "Z AI's latest model",
    descriptions: {
      en: "Z AI's latest model",
      zh: '智谱的最新模型',
    },
  },

  {
    icon: 'zai',
    label: 'GLM 4.5 V',
    value: 'glm-4.5v',
    creditsCost: 1,
    supportImage: true,
    description: "Z AI's latest model",
    descriptions: {
      en: "Z AI's latest model",
      zh: '智谱的最新的多模态模型',
    },
  },

  // {
  //   icon: 'seede',
  //   label: "Seede",
  //   value: "seede",
  //   creditsCost: 1,
  //   description: "Seede's first design agent",
  //   descriptions: {
  //     en: "Seede's first design agent",
  //     zh: "Seede 的设计 Agent",
  //   }
  // },
  // {
  //   icon: 'xai',
  //   label: "Grok 4",
  //   value: "grok-4",
  //   creditsCost: 2,
  //   isDev: true,
  //   description: "Grok 4",
  //   descriptions: {
  //     en: "Grok 4",
  //     zh: "Grok 4"
  //   }
  // },
];

export const devModels = [
  {
    icon: 'seede',
    label: 'Seede',
    value: 'seede',
    creditsCost: 1,
    description: "Seede's first design agent",
    descriptions: {
      en: "Seede's first design agent",
      zh: 'Seede 的设计 Agent',
    },
  },
  {
    icon: 'gemini',
    label: 'Gemini 2.5 Flash Search',
    value: 'gemini-2.5-flash-search',
    creditsCost: 1,
    description: "Seede's first design agent",
    descriptions: {
      en: "Seede's first design agent",
      zh: 'Seede 的设计 Agent',
    },
  },
];

export const skeletonPrompt = `
{{seede_skeleton_system}}

Poster size requirement: {{size}}
`;

export const systemPrompt = `
{{seede_screenshot_system}}

Poster size requirement: {{size}}
`;

export const textSystemPrompt = `
{{seede_system}}

Poster size requirement: {{size}}
`;

export const EditSystemPrompt = `
{{seede_edit_system}}
`;

export const EditPartSystemPrompt = `
{{seede_edit_part_system}}
`;

export const SVGEditSystemPrompt = `
{{seede_svg_edit_system}}
`;

export const svgSystemPrompt = `
{{seede_svg_system}}

Poster size requirement: {{size}}
`;

const socialCard = `
{{seede_social_card_system}}

Poster size requirement: {{size}}
`;

export const PoeSystemPrompt = `
{{seede_peo_card_system}}

Poster size requirement: {{size}}
`;

const PoeSystemPromptV2 = `
{{seede_peo_card_v2_system}}

Poster size requirement: {{size}}
`;

export const internalPrompts = [
  {
    name: 'Default',
    prompt: textSystemPrompt,
  },
  {
    name: 'socialCard',
    prompt: socialCard,
  },
  {
    name: '古诗词大师',
    prompt: PoeSystemPrompt,
  },
  {
    name: '古诗词大师V2',
    prompt: PoeSystemPromptV2,
  },
];
